<template>
  <scout-form
    :label="label"
    :half="half"
    :is-modified="!!value"
  >
    <select
      :value="value"
      class="boss-input-select"
      @change="$emit('input', $event.target.value)"
    >
      <option value="">
        指定なし
      </option>
      <option
        v-for="(option ,i) in optionsWithSelected"
        :key="i"
        :value="option.id"
        :data-test="`option-${i}`"
      >
        {{ option.name }}
      </option>
    </select>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import _ from 'lodash'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      type: String
    },
    half: {
      default: false,
      type: Boolean
    },
    label: {
      required: true,
      type: String
    },
    options: {
      required: true,
      type: Array,
      validator: prop => _.every(prop, v => _.has(v, 'id') && _.has(v, 'name'))
    }
  },
  data () {
    return {
      optionsWithSelected: this.options
    }
  },
  watch: {
    options () {
      if (this.value === '') {
        this.$set(this, 'optionsWithSelected', this.options)
        return
      }

      // optionが変更されても、現在選択しているoptionは保持したい
      // ブラウザの都合上、プルダウン上での位置にも依存しているため、全項目引継ぐ
      this.optionsWithSelected.push(..._.differenceBy(this.options, this.optionsWithSelected, 'id'))
    }
  }
}
</script>
